
export default class ODataTableStorage {
  constructor(store) {
    this.store = store;
  }

  caricaStato = () => {
    if (this.store && window.sessionStorage) {
      const dati = window.sessionStorage.getItem(this.store);
      if (!dati) {
        return null;
      }
      return JSON.parse(dati);
    }
    return null;
  };

  salvaStato = (dati) => {
    if (this.store && window.sessionStorage) {
      window.sessionStorage.setItem(this.store, JSON.stringify(dati));
    }
  };
}
